import { SessionData } from "@auth0/nextjs-auth0/types"
import {
    ArrowLeftEndOnRectangleIcon,
    ChartBarIcon,
    ChatBubbleLeftRightIcon,
    CircleStackIcon,
    CloudIcon,
    Cog6ToothIcon,
    CurrencyDollarIcon,
    DocumentMagnifyingGlassIcon,
    HomeModernIcon,
    LightBulbIcon,
    BoltIcon,
    SparklesIcon,
    UsersIcon,
    BookOpenIcon,
    ShoppingCartIcon,
} from "@heroicons/react/24/outline"
import { clsx } from "clsx"
import Image from "next/image"
import LowerMenuItem from "domains/users/components/LowerMenuItem"
import { adminEmailAddresses } from "../../authz/components/AdminOnly"
import wideLogoImage from "../images/wide-logo.svg"
// import { auth0 } from "../../../lib/auth0"

export const navigation = [
    { name: "Home", href: "/", icon: HomeModernIcon, current: false, admin: false, public: true },
    { name: "Dashboard", href: "/admin/dashboard", icon: HomeModernIcon, current: false, admin: true },
    { name: "Data Analyzer", href: "/data-analyzer", icon: ChartBarIcon, current: false, admin: false, public: true },
    { name: "Assistant", href: "/assistants", icon: ChatBubbleLeftRightIcon, current: false, admin: true },
    {
        name: "PII Scanner",
        href: "/pii-scanner",
        icon: DocumentMagnifyingGlassIcon,
        current: false,
        admin: false,
        public: true,
    },
    { name: "Academy", href: "/academy", icon: LightBulbIcon, current: false, admin: false, public: true },
    // { name: "Cart", href: "/academy/cart", icon: ShoppingCartIcon, current: false, admin: false, public: true },
    { name: "Pulse", href: "/pulse", icon: BoltIcon, current: false, admin: false, public: true },
    {
        name: "Virtual Ray",
        href: "/labs/virtual-ray",
        icon: ChatBubbleLeftRightIcon,
        current: false,
        admin: false,
        public: true,
    },
    { name: "Word Clouds", href: "/word-clouds", icon: CloudIcon, current: false, admin: false, public: false },
    { name: "Team", href: "/team", icon: UsersIcon, current: false, admin: false },
    { name: "Organizations", href: "/admin/organizations", icon: HomeModernIcon, current: false, admin: true },
    { name: "Credits", href: "/admin/credits", icon: CurrencyDollarIcon, current: false, admin: true },
    { name: "Regions", href: "/admin/regions", icon: CircleStackIcon, current: false, admin: true },
    { name: "Billing", href: "/billing", icon: CurrencyDollarIcon, current: false, admin: false },
    { name: "Settings", href: "/settings", icon: Cog6ToothIcon, current: false, admin: false },
    { name: "Logout", href: "/auth/logout", icon: ArrowLeftEndOnRectangleIcon, current: false, admin: false },
]

interface Props {
    current?: string
    session: Promise<SessionData | null>
}

export function navigationView(session: SessionData | null, current?: string | undefined) {
    if (current) {
        navigation.forEach((item) => (item.current = false))
        const item = navigation.find((item) => item.name === current)
        if (item) {
            item.current = true
        }
    }

    const displayAdmin = adminEmailAddresses.includes(session?.user.email?.toLowerCase() ?? "")

    const unauthenticated = !session

    let filteredNavigation = navigation

    if (unauthenticated) {
        filteredNavigation = navigation.filter((n) => n.public)
    }

    return {
        displayAdmin,
        unauthenticated,
        items: filteredNavigation,
    }
}

export async function DesktopFrame({ current, session }: Props) {
    const { displayAdmin, items, unauthenticated } = navigationView(await session, current)

    return (
        <div className="bg-primary-800 dark:bg-primary-950 hidden w-72 grow flex-col gap-y-5 overflow-y-auto px-6 lg:fixed lg:inset-y-0 lg:z-50 lg:flex">
            <div className="flex h-16 shrink-0 items-center">
                <Image className="h-10 w-auto" src={wideLogoImage} priority alt="ResearchWiseAI Logo" />
            </div>
            <nav className="flex flex-1 flex-col">
                <ul className="flex flex-1 flex-col gap-y-7">
                    <li>
                        <ul className="-mx-2 space-y-1">
                            {items
                                .filter((n) => !n.admin || displayAdmin)
                                .map((item) => (
                                    <li key={item.name}>
                                        <a
                                            href={item.href}
                                            className={clsx(
                                                item.current
                                                    ? "bg-primary-950 dark:bg-primary-900 text-white"
                                                    : "text-primary-50 hover:bg-primary-950 dark:hover:bg-primary-900 hover:text-white",
                                                "group flex gap-x-3 rounded-md p-2 leading-6 font-semibold"
                                            )}
                                        >
                                            <item.icon
                                                className={clsx(
                                                    item.current
                                                        ? "text-white"
                                                        : "text-primary-50 group-hover:text-white",
                                                    "size-6 shrink-0"
                                                )}
                                                aria-hidden="true"
                                            />
                                            {item.name}
                                            {item.admin && <SparklesIcon className="size-4 text-amber-300" />}
                                        </a>
                                    </li>
                                ))}
                        </ul>
                    </li>
                    <LowerMenuItem unauthenticated={unauthenticated} />
                </ul>
            </nav>
        </div>
    )
}
